var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSalesAndCrmIcon = function SvgSalesAndCrmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M12.313 51.5H10.25A8.25 8.25 0 0 1 2 43.25V35a8.25 8.25 0 0 1 8.25-8.25h2.063a2.06 2.06 0 0 1 2.062 2.063v20.625a2.06 2.06 0 0 1-2.062 2.062M59.75 51.5h-2.062a2.06 2.06 0 0 1-2.063-2.062V28.812a2.06 2.06 0 0 1 2.063-2.062h2.062A8.25 8.25 0 0 1 68 35v8.25a8.25 8.25 0 0 1-8.25 8.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M10.25 26.75A24.75 24.75 0 0 1 35 2v0a24.75 24.75 0 0 1 24.75 24.75M43.25 63.875h7.071c2.501 0 4.9-1.043 6.667-2.9 1.769-1.856 2.762-4.374 2.762-7V51.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M39.125 68H35a4.125 4.125 0 0 1 0-8.25h4.125a4.125 4.125 0 0 1 0 8.25"
  })));
};
export default SvgSalesAndCrmIcon;